import { Extension } from '@tiptap/core';

// Keeps paragraph indentation and spacing (e.g. from Word) on paragraphs and headings
const PROPS = {
  marginLeft: 'margin-left',
  textIndent: 'text-indent',
  marginTop: 'margin-top',
  marginBottom: 'margin-bottom',
  lineHeight: 'line-height',
};

export const ParagraphStyle = Extension.create({
  name: 'paragraphStyle',
  addGlobalAttributes() {
    return [{
      types: ['paragraph', 'heading'],
      attributes: Object.fromEntries(Object.entries(PROPS).map(([key, css]) => [key, {
        default: null,
        parseHTML: (el) => el.style.getPropertyValue(css) || null,
        renderHTML: (attrs) => (attrs[key] ? { style: `${css}: ${attrs[key]}` } : {}),
      }])),
    }];
  },
});
